import React from 'react'

import Analytics from './HOC/Analytics'
import Title from './HOC/Title'
import Unsupported from '../components/Unsupported'

function UnsupportedContainer() {
  return <Unsupported />
}

export default Title(Analytics(UnsupportedContainer), 'Cadastrado com sucesso na Hi Platform')



// WEBPACK FOOTER //
// ./src/containers/Unsupported.js